import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

export default function Faq() {
  const { t } = useLang();

  return (
    <section id="faq" data-testid="faq-section" className="bg-[#F3EFEA] py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C87A57]">{t.faq.overline}</p>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-tight text-[#0E1B2A] text-balance">
            {t.faq.title}
          </h2>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="overflow-hidden rounded-xl border border-[#0E1B2A]/8 bg-white px-6 transition-shadow duration-300 data-[state=open]:shadow-[0_15px_35px_-10px_rgba(14,27,42,0.12)]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="py-5 text-left font-serif text-lg sm:text-xl font-semibold text-[#0E1B2A] hover:text-[#C87A57] hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm sm:text-base leading-relaxed text-[#475569]">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
